import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ng2-cookies';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  constructor(private http: HttpClient, private cookie: CookieService) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' })
  };

  builderHeader(){ 
    this.httpOptions = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + this.cookie.get('idToken'))
    }
  }

    postNoToken(url: string, obj: (any | FormData)): Observable<any> {
      return this.http.post<Observable<any>>(url, obj);
    }

    post(url: string, obj: (any | FormData)): Observable<any> {
      this.builderHeader();
      let data = this.http.post<Observable<any>>(url, obj, this.httpOptions);
      return data;
    }
  
    get(url: string, queryParams: any): Observable<any> {
      this.builderHeader();
      if (queryParams && queryParams!=null && Object.keys(queryParams).length > 0) {
        url += "?";
        Object.keys(queryParams).forEach(key => {
          url += key + "=" + queryParams[key] + "&";
        });
        url = url.substr(0, url.length - 1);
        
      }
      return this.http.get<Observable<any>>(url, this.httpOptions);
    }

    downloadFile(path: string): any {
      return this.http.get(path, {responseType: 'blob'});
    }

    checkEnvironmentIsDev():boolean{
      return environment.name == "DEV";
    }
}
